<template>
  <div class="know-box">
    <!-- 页面元素 -->
    <div class="know-header">
      <img
        class="know-logo"
        src="../assets/images/know/top_logo.png"
        alt="分享借"
      />
      <p class="know-slogan">正规持牌金融机构，应你之急</p>
    </div>
    <div class="know-card">
      <!-- 标题1 -->
      <div class="know-title">
        <div class="know-title-bar u-flex u-col-center">
          <span class="know-title-num">01</span>
          <span class="know-title-text">如何在分享借获得贷款？</span>
        </div>
        <p class="know-title-desc">
          仅需3步即可在分享借轻松获得最高200,000元贷款
        </p>
      </div>
      <!-- 内容1 -->
      <div class="know-cont know-cont1-box">
        <!-- 在首页点击提升额度 -->
        <div class="know-cont1">
          <div class="know-cont1-bar u-flex u-col-center">
            <span class="know-cont1-tit">1-在首页点击提升额度</span>
          </div>
          <div class="know-cont1-cont">
            首页点击<span class="know-cont1-key">「提升额度」</span>
            按钮进入信息采集页面，按照页面中的引导依次如实完成资料填写，这一步大概率会让你使用2分钟的时间进行。完成后你有机会获得2张提额券。
          </div>
        </div>
        <!-- 完成资料提交 -->
        <div class="know-cont1">
          <div class="know-cont1-bar u-flex u-col-center">
            <span class="know-cont1-tit">2-完成资料提交</span>
          </div>
          <div class="know-cont1-cont">
            信息采集完成后点击页面中<span class="know-cont1-key"
              >「下一步」</span
            >
            按钮提交您的贷款申请，您的贷款申请预计再5分钟内可以完成审核，在此期间建议您开启通知权限，及时获知审核结果。
          </div>
        </div>
        <!-- 完成提款 -->
        <div class="know-cont1">
          <div class="know-cont1-bar u-flex u-col-center">
            <span class="know-cont1-tit">3-完成提款</span>
          </div>
          <div class="know-cont1-cont">
            额度审核完成后，在首页点击<span class="know-cont1-key"
              >「提款」</span
            >
            按钮，绑定您的银行卡，配合安全方面考虑，需要你完成人脸识别，操作完成后，资金将在10分钟内打款到您的指定账户。
          </div>
        </div>
      </div>
    </div>
    <div class="know-card">
      <!-- 标题2 -->
      <div class="know-title">
        <div class="know-title-bar u-flex u-col-center">
          <span class="know-title-num">02</span>
          <span class="know-title-text">如何还款到分享借？</span>
        </div>
      </div>
      <!-- 内容2 -->
      <div class="know-cont2-box">
        <img
          class="know-cont2-decor"
          src="../assets/images/know/icon_blue.png"
          alt=""
        />
        <div class="know-cont2-head u-flex u-col-center">
          <img
            class="know-cont2-icon"
            src="../assets/images/know/icon_upload.png"
            alt=""
          />
          <div class="know-cont2-tit">手动还款</div>
        </div>
        <div class="know-cont2-cont">
          您贷款提取完成后，首页会为您生成还款计划，您可以按照还款计划中约定的时间，按照页面指引操作还款，为了避免逾期导致征信不良，建议您开启通知获得还款信息。
        </div>
      </div>
      <!-- 内容2 -->
      <div class="know-cont2-box">
        <img
          class="know-cont2-decor"
          src="../assets/images/know/icon_blue.png"
          alt=""
        />
        <div class="know-cont2-head u-flex u-col-center">
          <img
            class="know-cont2-icon"
            src="../assets/images/know/icon_card.png"
            alt=""
          />
          <div class="know-cont2-tit">自动还款</div>
        </div>
        <div class="know-cont2-cont">
          在您的贷款申请审核通过后，绑定银行卡进行提款操作时，勾选页面中「同步绑定为还款卡」按钮，同时勾选「三方代扣协议」，我们将为您开通自动还款功能，会根据还款计划自动从绑定的银行卡中扣款，为了避免扣款失败导致的逾期问题，请您在绑定的银行卡中预留足够的资金。
        </div>
      </div>
    </div>
    <div class="know-card">
      <!-- 标题3 -->
      <div class="know-title">
        <div class="know-title-bar u-flex u-col-center">
          <span class="know-title-num">03</span>
          <span class="know-title-text">如何提升分享借的额度？</span>
        </div>
      </div>
      <!-- 内容3 -->
      <div class="know-cont know-cont1-box">
        <div class="know-cont1">
          <div class="know-cont1-bar u-flex u-col-center">
            <span class="know-cont1-tit">1-确保信息真实有效</span>
          </div>
          <div class="know-cont1-cont">
            借款人在提交自己的个人信息资料时，确保所填信息真实有效。写的信息越完善，所获得贷款额度可能就越高。
          </div>
        </div>
        <div class="know-cont1">
          <div class="know-cont1-bar u-flex u-col-center">
            <span class="know-cont1-tit">2-保持良好的还款记录</span>
          </div>
          <div class="know-cont1-cont">
            良好的还款习惯将提升您的综合信用评分。贷款机构会根据用户的还款记录评定用户的个人信用，保证按时还款，拥有良好的还款记录。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Know",
};
</script>

<style lang="scss" scoped>
.know-box {
  background-color: #f1f2f6;
  // background-image: linear-gradient(
  //     180deg,
  //     transparent 0,
  //     transparent calc(7.5rem * 638 / 1500),
  //     #a0b5fd calc(7.5rem * 638 / 1500),
  //     #f1f2f6 calc(7.5rem * 638 / 1500 + 1.2rem)
  //   ),
  //   url("../assets/images/know/top_bg.png");
  background-image: url("../assets/images/know/top_bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  // 有按钮时的padding
  // padding: 0.6rem 0.4rem 2.88rem;
  // 没有按钮时的padding
  padding: 0 0.4rem 0.6rem;

  .know-header {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 3.2rem;
    padding: 0 0.4rem 0.32rem;
  }

  .know-logo {
    display: block;
    width: 2.81rem;
    height: 0.74rem;
  }

  .know-slogan {
    margin-top: 0.13rem;
    color: #ffffff;
    line-height: 0.34rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 0.26rem;
  }

  .know-card {
    padding: 0.4rem 0.3rem 0.3rem;
    margin-bottom: 0.24rem;
    background: #fff;
    border-radius: 0.24rem;

    &:first-of-type {
      border-radius: 0.32rem 0.32rem 0.24rem 0.24rem;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .know-title {
      margin-bottom: 0.25rem;

      &-bar {
        width: 100%;
        aspect-ratio: 1240 / 160;
        background: url("../assets/images/know/title_bg.png") no-repeat center /
          100% 100%;
      }

      &-num {
        flex: 0 0 22%;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #fff;
        line-height: 1;
      }

      &-text {
        flex: 1;
        padding: 0 0.2rem 0 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 0.28rem;
        color: #678cf9;
        line-height: 0.4rem;
      }

      &-desc {
        margin-top: 0.12rem;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        line-height: 0.4rem;
      }
    }

    .know-cont {
      .know-cont-tit {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #111c31;
        line-height: 0.34rem;
      }
    }

    .know-cont1-box {
      .know-cont1 {
        margin-bottom: 0.4rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .know-cont1-bar {
        display: flex;
        align-items: center;
        width: 3.8rem;
        height: 0.65rem;
        background: url("../assets/images/know/text_bg.png") no-repeat center /
          100% 100%;
      }

      .know-cont1-tit {
        padding: 0 0.48rem 0.09rem;
        font-size: 0.28rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #fff;
        white-space: nowrap;
      }

      .know-cont1-cont {
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        text-align: justify;
        color: #666666;
        line-height: 0.4rem;
        margin-top: 0.16rem;

        .know-cont1-key {
          color: #7495f9;
        }
      }
    }

    .know-cont2-box {
      position: relative;
      margin-bottom: 0.24rem;
      padding: 0.24rem 0.24rem 0.16rem;
      background: #ebf0fc;
      border-radius: 0.12rem;

      &:last-child {
        margin-bottom: 0;
      }

      .know-cont2-decor {
        position: absolute;
        top: 0.16rem;
        right: 0.16rem;
        display: block;
        width: 0.32rem;
        height: 0.12rem;
      }

      .know-cont2-head {
        margin-bottom: 0.16rem;
        padding-right: 0.4rem;
      }

      .know-cont2-icon {
        display: block;
        width: 0.28rem;
        height: 0.26rem;
        margin-right: 0.12rem;
      }

      .know-cont2-tit {
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #678cf9;
        line-height: 0.4rem;
      }

      .know-cont2-cont {
        padding: 0.24rem;
        background: #fff;
        border-radius: 0.12rem;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        text-align: justify;
        color: #666666;
        line-height: 0.4rem;

        .know-cont1-key {
          color: #7495f9;
        }
      }
    }
  }
}
</style>
